import React from "react";
import { useAuth } from "../context/authContext";
import { CreatePlaceProvider } from "../context/CreatePlaceContext";
import { UserContextProvider } from "../context/UserContext";
import Authenticated from "./Authenticated";
import UnAuthenticated from "./unAuthenticated";

const Router = () => {
  const {token} =useAuth()
  return (
    <div>
       <UserContextProvider>
      <CreatePlaceProvider>
       {
         token ? <Authenticated />:<UnAuthenticated />
       }
      </CreatePlaceProvider>
      </UserContextProvider>
    </div>
  );
};

export default Router;
